export default "__VITE_ASSET__bb9f04b2__"